import { FeatureCollection, Point } from 'geojson';

import { ZoningFeatureCollection } from '@data-access';

export interface SamplingPlansListItem {
  id: number;
  farm: {
    id: number;
    name: string;
  };
  ilot_id: number | null;
  field_teledec_id: number | null;
  organizations: {
    id: number;
    name: string;
  }[];
  analysis_type: string;
  nbr_samples: string;
  nbr_points: string;
  area: string;
  status: string;
}

export type SamplingPlansListResponse = {
  count: number;
  next: string | null;
  previous: string | null;
  results: SamplingPlansListItem[];
};

export interface SamplingPlanDetailsResponse {
  id: number;
  name: string;
  account: {
    id: number;
    first_name: string;
    last_name: string;
  };
  analysis_type: string;
  ilot_id: number | null;
  field_teledec_id: number | null;
  status: string;
  created_at: string;
  updated_at: string;
  samples: Sample[];
  nbr_points: number | null;
  zoning_method: string | null;
  erosion: string | null;
  map: ZoningFeatureCollection;
}

export type PointFeatureCollection = FeatureCollection<Point, PointProperties>;

export type Sample = {
  id: string;
  zone: number;
  code: string;
  carbon_content?: number | null;
  soil_density?: number | null;
  points: PointFeatureCollection;
  created_at: string;
  updated_at: string;
  status: string;
};

export type PointProperties = {
  zone: number;
  code: string;
  status: string;
  conditions: string | null;
  field_id: number | null;
  field_name: string;
  analysis_type: string;
  sampled_at: string | null;
  comment: string | null;
};

export enum SampleStatus {
  PENDING = 'PENDING',
  SENT = 'SENT',
  RECEIVED = 'RECEIVED',
  ANALYZED = 'ANALYZED',
  ERROR = 'ERROR',
  FINISHED = 'FINISHED',
}

export type SamplingPlansValuesFilters = {
  contract?: string;
  analysis_type?: string;
  field?: string;
  nbr_points?: string;
  zoning_method?: string;
};

export interface SamplingPlanDto {
  contract: string;
  analysis_type: string;
  field: string | null;
  nbr_points: string;
  zoning_method: string;
}

export interface CarbonPlanDebugDetails {
  id: number;
  nbr_points: number;
  zoning_method: string;
  erosion: number;
  restart: boolean;
}
export type CarbonPlanDebugDto = Omit<CarbonPlanDebugDetails, 'id'>;

export interface DensityPlanDebugDetails {
  id: number;
  nbr_points: number;
  zoning_method: string;
  erosion: number;
  restart: boolean;
}
export type DensityPlanDebugDto = Omit<DensityPlanDebugDetails, 'id'>;

export interface SamplingPlansValuesResponse {
  contract: {
    id: number;
    clause: string;
    farm: {
      id: number;
      name: string;
    };
  }[];
  analysis_type: {
    value: string;
    label: string;
  }[];
  field: {
    id: number;
    thumbnail: string;
    name: string;
    species: null | {
      id: number;
      name: string;
      code: string;
      unit: string;
    };
    farm: {
      id: number;
      name: string;
    };
    area: number;
    color: string;
  }[];
  nbr_points: {
    value: number;
    label: string;
  }[];
  zoning_method: {
    value: string;
    label: string;
  }[];
  erosion: { value: number; label: string }[];
}

export interface SamplingPlanMapItem {
  id: number;
  samples: Sample[];
  analysis_type: string;
  status: string;
  created_at: string;
  updated_at: string;
}

export type SamplingPlansMapsResponse = SamplingPlanMapItem[];
